/**
 * Serializes the *calendar date* the instructor picked as a UTC-midnight ISO string.
 *
 * The backend treats DateStart as a calendar-date carrier (its .Date drives all
 * recurrence math), and the wall-clock time lives separately in TimeLocal +
 * TimeZone. Plain `toISOString()` on a local-midnight Date shifts the calendar
 * date for any browser east of UTC — this keeps the picked date intact.
 */
export function toCalendarDateISO(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}T00:00:00.000Z`;
}
